/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelExcisetaxChargeBill.ts           *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/ar/excisetax-charge-bill";

export class AutogenModelExcisetaxChargeBill<RowType extends ModelRow> extends Endpoint<RowType, RowExcisetaxChargeBillFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowExcisetaxChargeBill extends ModelRow<RowExcisetaxChargeBillFields> {
	constructor(values?: Partial<RowExcisetaxChargeBillFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowExcisetaxChargeBillFields {
	amount: number;
	amount_c: string;
	amount_d: Date;
	amount_n: number;
	amount_r: number;
	bill_type: string;
	company_id: string;
	customer_id: string;
	descr: string;
	excisetax_id: string;
	id: string;
	invoice_id: string;
	is_estimated: string;
	method: string;
	order_excisetax_id: string;
	order_id: string;
	rate: number;
	state_id: string;
	tax_date: Date;
	units: number;
}

